// TODO: make this file isomorphic, i.e. remove duplication with /server version
export function getWeeksBetween(d1, d2) {
	var weekInMilliseconds = 7 * 24 * 60 * 60 * 1000;
  return Math.round((d2 - d1) / weekInMilliseconds);
}

export function dateToWeekEnding(date) {
	const currentDay = date.getDay();
	const toAdd = currentDay ? (7 - currentDay) : 0;
	const newDate = new Date(date.getTime());

	newDate.setDate(newDate.getDate() + toAdd); 

	return newDate;
}

export function calculateWeeksWorked(startDate, weekEnding) {
	return getWeeksBetween(dateToWeekEnding(new Date(startDate)), new Date(weekEnding));
}


// WEBPACK FOOTER //
// ./src/utils/weeks.js